;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/ScoreHotfix/SagePictureAsBackground',["score_bootstrap/Base/PictureAsBackground"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("score_bootstrap/Base/PictureAsBackground")) :
        console && console.error('PictureAsBackground does not support non-amd script loading.');
}(this/* window */, function (ScorePictureAsBackground) {

    function PictureAsBackground($scope, picSelector, eePicSelector) {
        ScorePictureAsBackground.call(this, $scope, picSelector, eePicSelector);
    }

    PictureAsBackground.prototype = Object.create(ScorePictureAsBackground.prototype);

    PictureAsBackground.prototype._resizeHandler = function () {
        this._updateBackgroundWhenImageLoaded();
    }

    return PictureAsBackground;
}));
